export var verizonTheme = {
    colors: {
        primary: "#D52B1E",
        secondary: "#000",
        tertiary: "#FFFFFE",
        white: "#FFFFFE",
        grayDark: "#333333",
        grayMid: "#747676",
        grayLight: "#D8DADA",
        grayLighter: "#F6F6F6",
        green: "#00AC3E",
        greenLight: "#57C880",
        greenLighter: "#ABE4BF",
        blue: "#0088CE",
        blueLight: "#57B0DF",
        blueLighter: "#ABD8EF",
        yellow: "#FFBC3D",
        yellowLight: "#FFD37F",
        yellowLighter: "#FFE9BF",
        orange: "#ED7000",
        orangeLight: "#F3A157",
        orangeLighter: "#F9D0AB",
    },
    typography: {
        bodyColor: "#000",
        fontFamily: "'Verizon NHG DS', 'neue-haas-grotesk-display', sans-serif",
        fontSize: "100%",
        title: {
            fontSize: 75,
            fontSizeMobile: 48,
            fontSizeTablet: 75,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading2: {
            fontSize: 60,
            fontSizeMobile: 40,
            fontSizeTablet: 48,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading3: {
            fontSize: 40,
            fontSizeMobile: 24,
            fontSizeTablet: 24,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading4: {
            fontSize: 32,
            fontSizeMobile: 24,
            fontSizeTablet: 32,
            lineHeight: "1.2",
            fontWeight: "bold",
        },
        heading5: {
            fontSize: 32,
            fontSizeMobile: 24,
            fontSizeTablet: 32,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        heading6: {
            fontSize: 24,
            fontSizeTablet: 24,
            fontSizeMobile: 24,
            lineHeight: "1.2",
            fontWeight: "normal",
        },
        body: {
            fontSize: 16,
            fontSizeMobile: 16,
            fontSizeTablet: 16,
            lineHeight: "1.5",
            fontWeight: "normal",
        },
    },
};
